import { IRequest } from './IRequest'
import { RequestTypes } from './Onboarding'

export enum ERetailRequestSubmitted {
  initial = 0,
  notApproved = 1,
  allStepsAreDoneAndSaved = 2,
  reopened = 3,
}

export interface IRetailRequest extends IRequest {
  RegistrationStatus: string
  ContractualOnboardingStatus: string
}

export interface IRequestDataExt extends IRequestData {
  RequestUid?: string
  TemplateUUID?: string
  ChildReqDetailedStatus: string
  ChildReqId: number
  ChildReqIssueOutDate: Date
  ChildReqRequestProgress: number
  ChildReqCompletedDate: Date
  ApprovalActionIsDone: number
  AgreementIsDone: number
  RejectionComment: string
  RejectionReasonComment: string
  ApprovalActionCompletedBy: string
  RejectedBy: string
  LegalWorkflowStatus: string
  WorkflowStatus: string
  LocationId: string
}

export interface IRequestData {
  MainParameter: BPRegMainParams //?
  EntryId: string
  PartnerId: string
  BPISRRecipients: string
  EmailActionIsDone: number
  PartnerIdByEmail?: string
  ContactIdByEmail?: string
  Progress: number
  PartnerTrack: string
  PartnerName: string
  AgreementExisting: number
  AgreementScenario1Flag: number
  CommunicationName: string
  Data: string
  RequestId: number
  Submitted: ERetailRequestSubmitted
  TopPartnerId: string
  HierarchyType: string
  GeoMarket: string
  GeoRegion: string
  EmailActionId: number
  Type: RequestTypes
  Country: string
  CountryISO: string

  //3step
  CompanyEnglishName: string
  CompanyLegalName: string
  TaxId: string
  LegalAddress1: string
  LegalAddress2: string
  LegalAddress3: string
  LegalCity: string
  LegalState: string
  LegalCountry: string
  LegalPostalCode: string
  CompanyURL: string
  CADisabled: number
  DCCDisabled: number
  GMDisabled: number
  HPCDisabled: number
  PPADisabled: number
  Status: string
  RequestorEmail: string
  Requestor: string

  // not needed
  BussinessSurveyNotNeeded: number
  TermsAndConditionsNotNeeded: number
  CompanyDataNotNeeded: number
  ContactDataNotNeeded: number
  EmailValidationNotNeeded: number

  ContinueRegAid: number
  ContinueRegTrId: number
  StopRegTrId: number

  MainParam: BPRegMainParams

  Modified: string
}

export enum BPRegMainParams {
  SelfRegistr = 'BP_SR',
  SimpleSelfRegistr = 'SPR',
  HPAttended = 'BP_HPA',
  InviteRegistr = 'BP_RBI',
  BPReconfirmation = 'BP_Reconfirm',
  test = 'bp_rbi_test',
}

export enum RetailRequestMainParameter {
  SynergyRetail = 'synergy_retail',
  PowerRetail = 'power_retail',
  PowerCDRRetail = 'power-cdr_retail',
}

export interface IEditableRequestData {
  LegalUpdated: number
  PhysicalUpdated: number
  LastStep: number
  PartnerId: string
  legalFilesAreUploaded?: number
  EntryId406: string
  EntryId502: string
  PartnerWillBeContacted: number
  RetailerOperatesOnlyOnline: number
  DoneSteps: string
  AcknowledgeRetailerBriefing: number
  AgreementStatus: number
  CompanyInformation: number
  BusinessInformation: number
  ContactDetails: number
  AgreementStatusText: string
  SubmittedUser: string
  SubmittedDate: string
  //1step
  CRConfirmation: string
  CREmail: string
  CRFirstName: string
  CRLastName: string
  RAMEmail: string
  RAMFirstName: string
  RAMLastName: string
  KeyProgramComponents: string
  RetailCompensationElements: string
  PartnerDataSharing: string
  PartnerFacingMaterial: string
  //3step
  ContractTeamContact: string
  CompanyEnglishName: string
  CompanyLegalName: string
  TaxId: string
  LegalAddress1: string
  LegalAddress2: string
  LegalAddress3: string
  LegalCity: string
  LegalState: string
  LegalCountry: string
  LegalPostalCode: string
  PhysicalIsLegal: number
  CommunicationName: string
  Address1: string
  Address2: string
  Address3: string
  City: string
  State: string
  Country: string
  PostalCode: string
  MainPhoneCountryCode: string
  MainPhone: string
  Email: string
  CompanyURL: string
  ECommerceWeDontSellOnline: string | number
  ECommerceUrls: string
  DCCEmail: string
  DCCFirstName: string
  DCCLastName: string
  DCCWorkPhone: string
  DCCWorkPhoneCode: string
  CAEmail: string
  CAFirstName: string
  CALastName: string
  CAWorkPhone: string
  CAWorkPhoneCode: string
  GMEmail: string
  GMFirstName: string
  GMLastName: string
  GMWorkPhone: string
  GMWorkPhoneCode: string
  PPAEmail: string
  PPAFirstName: string
  PPALastName: string
  PPAWorkPhone: string
  PPAWorkPhoneCode: string
  HPCEmail: string
  HPCFirstName: string
  HPCLastName: string
  HPCWorkPhone: string
  HPCWorkPhoneCode: string
  //4 step
  CapSalesShareOffline: string
  CapSalesShareOnline: string
  CapSalesShareOnlineOwnSite: string
  CapSalesShareOnline3PSite: string
  CapPrefferableExperienceProgram: string
  CapHPPercentageComingFrom3P: string
  CapOperateOnlineMarketplace: string
  CapPhysicalStoresCount: string
  CapPartnerHasSalesEngine: string
  TeleSalesReps: string
  B2BSalesReps: string
  RepPartnerHasERP: string
  RepPartnerHasERPComment: string
  RepPartnerHasAPI: string
  RepPartnerHasAPIComment: string
  RepPartnerHas3PIntegration: string
  RepPartnerHas3PIntegrationComment: string
  PhoneAudits: string
  PhoneAuditsPhone: string
  PhoneAuditsWorkTime: string
  InstoreAuditsTemplateLink: string
  InstoreAuditsFileUploaded: string
  //Online Capability questions
  SiteSearchFunction: string
  HpProductsSale: string
  LogToSeePricing: string
  SiteCanNotBeScraped: number
  //RetailerSegmentation
  ResellerType: string
  ResellerSubCategory: string
  RouteToMarket: string
  OnlineSelling: string
  //Hybrid
  HybridReportingRequirements: string
  HybridApproval: number
  LegalRegulatory: number
  LRFirstName: string
  LRLastName: string
  LREmail: string
  LRWorkPhone: string
  LRWorkPhoneCode: string
}
